import { useState, useEffect } from 'react';
import { Skeleton, Grid } from '@mui/material';
import { useUser, useAuth } from '@clerk/clerk-react';

import CardDisplay from './CardDisplay';
import * as Api from '../Api';
import AddCardButton from './AddCardButton';

const CardList = () => {
  const [cards, setCards] = useState(null);
  const { user } = useUser();
  const { getToken } = useAuth();

  function renderSkeleton() {
    // TODO generate this array based on screen size
    const x = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
    return [
      x.map((y) => (
        // TODO make this grid item reusable class
        <Grid item xs={2} sm={4} md={4} key={y}>
          {/* TODO rounded corners here */}
          <Skeleton variant='rectangular' style={{ width: '400px', height: '250px' }} />
        </Grid>
      )),
    ];
  }

  // TODO when shrinking screen cards can slightly overlap before they wrap, fix it
  function renderCards() {
    return [
      cards &&
        cards.map((card) => (
          <Grid key={card.id} item xs={2} sm={2} md={4} xl={3}>
            <CardDisplay card={card}></CardDisplay>
          </Grid>
        )),
      <Grid key='idk' item xs={2} sm={2} md={4} xl={3}>
        <AddCardButton key='idk'></AddCardButton>
      </Grid>,
    ];
  }

  // TODO intervals and renews are returning as empty string
  useEffect(() => {
    getToken().then((token) => {
      // TODO: check if user has stripe_id, if not, create one or have some sort of fallback
      // wrap that in a function, find all other places in the code we get stripe_id like this
      let user_id = user.publicMetadata.stripe_id;
      //i think there might be a race condition where stripe id is not quite saved in time right after signup
      //so wait a bit and try again? TODO do better
      if (!user_id) {
        setTimeout(function () {}, 1000);
        user_id = user.publicMetadata.stripe_id;
      }
      Api.call(token, 'GET', `dashboard?user_id=${user_id}`).then((data) => {
        setCards(data);
      });
    });
  }, []);

  return (
    // putting a tiny margin on this causes the grid items to grow vertically... dunno why
    <Grid
      style={{ marginTop: '5px', marginLeft: '10px' }}
      container
      spacing={{ xs: 2, md: 3 }}
      columns={{ xs: 2, sm: 4, md: 8, lg: 12, xl: 12 }}
    >
      {cards != null ? renderCards() : renderSkeleton()}
    </Grid>
  );
};

export default CardList;
